import { Box, styled } from '@mui/material';

const StyledDrawerMenuLogotypeContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
  width: '162px',
  // El logotipo es blanco; en claro (sidebar blanco) hay que oscurecerlo.
  '& svg': { filter: theme.palette.mode === 'light' ? 'brightness(0)' : 'none' },
  [theme.breakpoints.up('lg')]: {
    margin: 0,
    width: 'auto'
  }
}));

export default StyledDrawerMenuLogotypeContainer;
